import { useCompanyPermissionsGet } from 'core/types'
import { Select } from 'peach/components'
import { useParams } from 'peach/router'

const CompanyPermissionSelect = ({ omitPermissions, ...rest }) => {
  const omitIndex = _.keyBy(omitPermissions, 'action')

  const { companyId } = useParams<{ companyId?: string }>()

  const { data: companyPermissions = [] } = useCompanyPermissionsGet({
    companyId,
  })

  const filteredPermission = _.reject(
    companyPermissions,
    ({ action }) => omitIndex[action],
  )

  const options = _.map(filteredPermission, (permission) => {
    const { action } = permission

    return { value: action, label: action }
  })

  return <Select {...rest} searchable label='Permission' options={options} />
}

export default CompanyPermissionSelect
